import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { format } from 'date-fns';
import { UsageStats } from '../../types';

interface UsageChartProps {
  data: UsageStats[];
  period: 'day' | 'week' | 'month';
}

const UsageChart: React.FC<UsageChartProps> = ({ data, period }) => {
  // Group data by period
  const groupedData = data.reduce((acc, curr) => {
    const date = new Date(curr.timestamp);
    let key = '';
    
    switch (period) {
      case 'day':
        key = format(date, 'yyyy-MM-dd');
        break;
      case 'week':
        key = `Week ${format(date, 'w')} - ${format(date, 'yyyy')}`;
        break;
      case 'month':
        key = format(date, 'MMMM yyyy');
        break;
    }

    if (!acc[key]) {
      acc[key] = { period: key, uses: 0 };
    }
    acc[key].uses += 1;
    return acc;
  }, {} as Record<string, { period: string; uses: number }>);

  const chartData = Object.values(groupedData);

  return (
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData}>
          <XAxis dataKey="period" angle={-45} textAnchor="end" height={80} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="uses" fill="#0891b2" name="Number of Uses" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UsageChart;